import { type FC } from 'react'

import { Card, Checkbox, FormLabel } from 'base-ui'

type CategoryEntry = {
  isChecked: boolean
  key: string
  label: string
}

type MarketplacePartnerRegisterPageFormCategoriesSelectionCardProps = {
  'data-qa-id': string
  entries: CategoryEntry[]
  id: string
  label: string
  onCheck: (key: string, checked: boolean) => void
}

export const MarketplacePartnerRegisterPageFormCategoriesSelectionCard: FC<
  MarketplacePartnerRegisterPageFormCategoriesSelectionCardProps
> = ({ 'data-qa-id': qaId, entries, id, label, onCheck }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <FormLabel className="text-xl text-dark-primary-max" htmlFor={id}>
        {label}
      </FormLabel>
      <Card
        className="flex min-h-96 min-w-96 flex-col justify-center border border-dark-primary-min bg-transparent p-4"
        data-qa-id={qaId}
        id={id}
      >
        {entries.map((entry) => {
          const checkboxId = `${id}-${entry.key}`

          return (
            <div className="flex items-center p-1" key={entry.key}>
              <Checkbox
                checked={entry.isChecked}
                id={checkboxId}
                onChange={(event) => {
                  onCheck(entry.key, event.target.checked)
                }}
              />
              <FormLabel className="ml-2" htmlFor={checkboxId}>
                {entry.label}
              </FormLabel>
            </div>
          )
        })}
      </Card>
    </div>
  )
}
